// extracted by mini-css-extract-plugin
export default {"bot-builder":"styles_bot-builder__Ya7mN","control-panel":"styles_control-panel__ya8Xn","options":"styles_options__TBgvl","option":"styles_option__YlYtG","show":"styles_show__2TYAD"};